import {NumberCol, RenderStringCol, Table, ViewOnly} from "../../../../misc/scroller/Table";
import {api} from "../../../../api/API";
import {useProjectId, useProjectUnitSystem} from "../../shopdrawing/ProjectName";
import {AnchorDetail} from "../../../../api/Openings";
import {
    Button,
    DialogActions,
    DialogContent,
    DialogTitle,
} from "@mui/material";
import {Dialog2} from "../../../../misc/Dialog2";
import React from "react";
import {useIsQuote} from "../QuoteContainer";
import {useAlternative} from "../alternative/Alternative";
import {useAsync2} from "nate-react-api-helpers";
import useWindowSize from "react-use/lib/useWindowSize";

export function ReviewAnchors() {
    const project = useProjectId();
    const sys = useProjectUnitSystem();
    const isQuote = useIsQuote();
    const alt = useAlternative();

    if(!sys) return null;

    return (
        <Table<AnchorDetail>
            name={"anchors"}
            fetch={ctx => {
                return isQuote ? api.quoteOpenings.listAnchors({
                        project: project,
                        alternative: alt,
                    }) : api.openings.listAnchors({
                        project: project,
                    })
            }}
            fetchDeps={[project, alt, isQuote]}
            columns={[
                {
                    name: "Anchors",
                    width: 200,
                    editable: {
                        type: "custom",
                        render: (props) => {
                            return <AnchorDetailPopup
                                onCancel={props.onCancel}
                                frameAnchorProduct={props.row.frameAnchorProduct}
                                frameAnchorProductName={props.row.frameAnchorProductName}
                            />;
                        }
                    },
                    render: (data, col) => {
                        return data.frameAnchorProductName || "";
                    },
                },
                {
                    name: "Has Attachment",
                    width: 100,
                    render: data => {
                        return data.frameAnchorProductCatalog ? "Yes" : "No";
                    }
                },
                ViewOnly(NumberCol("Qty", "count")),
                RenderStringCol("-", () => ""),
            ]}
        />
    )
}

export function AnchorDetailPopup(props: {
    frameAnchorProductName: string;
    frameAnchorProduct: number;

    onCancel(): void;
}) {
    const result = useAsync2((input) => api.print.fileAsImage(input),
        {catalogForProduct: props.frameAnchorProduct},
        [props.frameAnchorProduct]);

    const fileSrc = result.result;
    const size = useWindowSize();

    return (
        <Dialog2 open onClose={props.onCancel} fullWidth maxWidth="xl">
            <DialogTitle>
                {props.frameAnchorProductName}
            </DialogTitle>
            <DialogContent>
                <div style={{height: 8}}/>
                {fileSrc ? <img
                    src={fileSrc}
                    alt="anchor-image"
                    style={{
                        height: size.height * 0.75,
                        width: "100%",
                        border: "1px solid black",
                        objectFit: "contain",
                    }}
                /> : <div>No File</div>}
            </DialogContent>
            <DialogActions>
                <Button onClick={() => props.onCancel()}>Close</Button>
            </DialogActions>
        </Dialog2>
    )
}